import script from "./DVIUpdateWorkOrderPackage.vue?vue&type=script&lang=ts&setup=true"
export * from "./DVIUpdateWorkOrderPackage.vue?vue&type=script&lang=ts&setup=true"

import "./DVIUpdateWorkOrderPackage.vue?vue&type=style&index=0&id=7cb02f54&lang=css"

const __exports__ = script;

export default __exports__